import { render, staticRenderFns } from "./discountCube.vue?vue&type=template&id=21b9febf&scoped=true&"
import script from "./discountCube.vue?vue&type=script&lang=js&"
export * from "./discountCube.vue?vue&type=script&lang=js&"
import style0 from "./discountCube.vue?vue&type=style&index=0&id=21b9febf&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21b9febf",
  null
  
)

export default component.exports